"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _Cookie = _interopRequireDefault(require("../../packages/Cookie"));
var _env = _interopRequireDefault(require("../../utilities/env"));
var _id_token = _interopRequireDefault(require("../id_token"));
const v2Endpoint = (0, _env.default)("REACT_APP_DCS_ENDPOINT");
const v3Endpoint = (0, _env.default)("REACT_APP_DCS_V3_ENDPOINT");
const DCS3_XClient = (0, _env.default)("REACT_APP_DCS_CLIENT");
const DCS3_ENDPOINT_MAP = {
  V2: v2Endpoint,
  V3: v3Endpoint
};
const useDCS3Api = function (version) {
  const request = _axios.default.create({
    baseURL: DCS3_ENDPOINT_MAP[version],
    headers: {
      "X-BRAND": "L",
      "X-CLIENT": DCS3_XClient,
      "X-VERSION": "1.0"
    }
  });
  request.interceptors.request.use(async function (config) {
    try {
      var _config$headers;
      const [id_token] = (0, _Cookie.default)("id_token");
      const [id_token_tmnab2cqa] = (0, _Cookie.default)("id_token_tmnab2cqa");
      const [id_token_local] = (0, _Cookie.default)("id_token_local");
      const auth = (process.env.NODE_ENV !== "production" ? id_token_local : undefined) || id_token || id_token_tmnab2cqa || _id_token.default || "";
      const headers = (_config$headers = config.headers) !== null && _config$headers !== void 0 ? _config$headers : {};
      headers.Authorization = auth;
      config.headers = headers;
      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  });
  const makeHeaders = function (headers, data) {
    return {
      ...(data !== null && data !== void 0 && data.responseType ? {
        responseType: data.responseType
      } : {}),
      ...(headers ? {
        headers
      } : {})
    };
  };
  return {
    get: function (path, headers) {
      return request.get(path, makeHeaders(headers));
    },
    post: function (path, data, headers) {
      return request.post(path, data, makeHeaders(headers, data));
    },
    patch: function (path, data, headers) {
      return request.patch(path, data, makeHeaders(headers, data));
    },
    put: function (path, data, headers) {
      return request.put(path, data, makeHeaders(headers, data));
    },
    delete: function (path, data, headers) {
      return request.delete(path, {
        headers,
        data
      });
    }
  };
};
var _default = exports.default = useDCS3Api;